define('mustache-language/lib/locale',['require','exports','module'],function(require,exports,module){
    var RE_SPLIT = /[_-]/,
        EN = 'en',
        EMPTY = '';

    var localeCache = {};
    /**
     * Convert locale strings to w3c notation, and split into primary/local parts
     * @param  {string} locale locale string
     * @return {object}        parsed and converted locale
     */
    return function (locale){
        if(localeCache[locale]){
            return localeCache[locale];
        }
        locale = locale || EN;
        var split = locale.split(/[_-]/),
            primary = split[0].toLowerCase(),
            local = (split[1] || EMPTY).toUpperCase();

        return (localeCache[locale] = {
            full    : primary + (local ? '-' + local :''),
            primary : primary,
            local   : local
        });
    }
});
